import React from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import LogisticsForm from './components/LogisticsForm';
import LogisticsSignatureResult from './components/LogisticsSignatureResult';

function App() {
  return (
    <>
      <Header />
      <div className='flex flex-col w-full lg:w-1/2 lg:mx-auto pt-6'>
        <div className='flex flex-col gap-y-6'>
          <LogisticsForm />
          <LogisticsSignatureResult />
        </div>
      </div>
      <Footer />
    </>
  );
}

export default App;
